// @ts-check


export class Logger {


  /**
   * @param {any} message
   * @param  {any[]} optionalParams
   */
  static doLog = (message, ...optionalParams) => {

    // @ts-ignore
    let PL_LOG_ENABLED = window.PL_LOG_ENABLED;
    // if (!PL_LOG_ENABLED) {
    //   return;
    // }

    console.log(message, ...optionalParams);
  };


};




